import { render, staticRenderFns } from "./OrganizationContactTable.vue?vue&type=template&id=0c8390b4&"
import script from "./OrganizationContactTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationContactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports